import { PaymentElementThemeType } from '@cloudbeds/payment-sdk';
import * as foundations from './foundations';
import * as components from './components';

export const PayByLinkTheme: PaymentElementThemeType = ({
  globalStyles: {
    body: {
      fontFamily: 'body',
      lineHeight: '24px',
    },
  },
  colorMode: 'light',
  foundations,
  components
});
